import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';
import { totalEngagementConfig } from '@/lib/analytics/kpis/instagram/totalEngagement';

export const totalEngagementsMVConfig = {
    ...totalEngagementConfig,
    id: 'engagements',
    name: 'kpi.instagram.total_engagement',
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
